module.exports = __webpack_public_path__ + "media/img/iryo/singular-only-you-64e9ad07c573b5afee0ec41884f06964.svg";